import { DropdownOption } from '@/shared/components/dropdown/ui/types';

const PRODUCT_CATALOG = {
  DoubleGisPro: {
    label: '2ГИС Про',
    translationKey: 'fieldsChoseProductOptions2gisPro',
  },
  Databases: {
    label: 'Базы данных',
    translationKey: 'fieldsChoseProductOptionsDatabase',
  },
  API: { label: 'API и SDK', translationKey: 'productApiSdkName' },
  VectorMaps: {
    label: 'Векторные карты',
    translationKey: 'productVectorMapsName',
  },
  OnPremise: { label: 'On-Premise', translationKey: 'onPremiseName' },
  DoubleGisLens: {
    label: '2ГИС Ситискан',
    translationKey: 'fieldsChoseProductOptions2gisLens',
  },
  PrintedProducts: {
    label: 'Печать карт',
    translationKey: 'productPrintedProductsName',
  },
  Geoflow: { label: '2ГИС Геопоток', translationKey: 'geoflowMonitoring' },
  Logistics: {
    label: '2ГИС Геопоток.Логистика',
    translationKey: 'geoflowLogistics',
  },
  MCP: { label: 'MCP-сервер 2ГИС', translationKey: 'mcpServer2gis' },
  SpecialProjects: {
    label: 'Индивидуальные решения',
    translationKey: 'productCustomSolutionsName',
  },
  Other: { label: 'Другое', translationKey: 'fieldsChoseProductOptionsOther' },
};

export type ProductValue = keyof typeof PRODUCT_CATALOG;

export const LEAD_PRODUCT_OPTIONS: DropdownOption[] = Object.entries(
  PRODUCT_CATALOG,
).map(([value, { label }]) => ({ value, label }));

export const FORM_PRODUCT_OPTIONS: DropdownOption[] = Object.entries(
  PRODUCT_CATALOG,
).map(([value, { translationKey }]) => ({ value, label: translationKey }));
